import { antragsZeit } from '@/domain/arbeitszeiten/entities/Arbeitszeit';

function isKompletteArbeitszeit(
  beginn: antragsZeit,
  ende: antragsZeit,
): boolean {
  return (
    (beginn.isChangeRequested && ende.isChangeRequested) ||
    (ende.time !== null &&
      !ende.isChangeRequested &&
      beginn.time !== null &&
      !beginn.isChangeRequested)
  );
}

function isStartzeit(beginn: antragsZeit, ende: antragsZeit): boolean {
  return (
    (beginn.isChangeRequested && !ende.isChangeRequested) ||
    (beginn.time !== null && ende.time === null)
  );
}

function isEndzeit(beginn: antragsZeit, ende: antragsZeit): boolean {
  return (
    (ende.isChangeRequested && !beginn.isChangeRequested) ||
    (beginn.time === null && ende.time !== null)
  );
}

export function getAntragsArt(
  beginn?: antragsZeit,
  ende?: antragsZeit,
): string {
  if (!beginn || !ende) return '';

  if (isKompletteArbeitszeit(beginn, ende)) return 'komplette Arbeitszeit';
  if (isStartzeit(beginn, ende)) return 'Arbeitszeitbeginn';
  if (isEndzeit(beginn, ende)) return 'Arbeitszeitende';

  return '';
}
